export default {

  selectAll() {
    return env.API.get('/soil-texture');
  },
}
